import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiUrl } from "../../../constants";

export const updateCustomer = createAsyncThunk(
  "customer/updateCustomer",
  async (data, thunkAPI) => {
    const state = thunkAPI.getState();
    const token = state.user.token;

    const customerData = {
      c_name: data.name,
      c_email: data.email,
      c_phonenumber: data.phone,
      c_address: data.address,
      c_city: data.city,
      c_country: data.country,
      c_postalcode: data.postalcode,
      c_latitude: data.latitude,
      c_longitude: data.longitude,
    };

    const queryParams = new URLSearchParams();
    queryParams.append("customer_id", data.c_id);

    const requestOptions = {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(customerData),
    };

    try {
      const response = await fetch(
        `${apiUrl}/update_customer?${queryParams.toString()}`,
        requestOptions
      );

      if (!response.ok) {
        let errorMessage = "Network response was not ok";
        try {
          const error = await response.json();
          errorMessage = error.msg || errorMessage;
        } catch (e) {
          errorMessage = await response.text();
        }
        throw new Error(errorMessage || "Unknown error occurred");
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error("Updating customer failed:", error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);
